// Tab-switcher for the My Account page's shared tab nav (account.twig). The
// nav markup is a direct port of the reference's wc-account__tabs-nav/-list/
// -item/-link/--active structure — plain <a href="#..."> links, no Bootstrap
// nav/nav-tabs/nav-item/nav-link classes, no data-toggle="tab". The account
// page itself stays a single page with in-place tab switching (not split
// into separate per-tab pages like the reference), so this module drives
// that switching directly instead of relying on Bootstrap's tab.js — replaces
// the old accountTabHistory() method in account.js, which depended on
// Bootstrap's `.tab('show')` and a `.nav`/`.list-group` ancestor class to
// correctly deactivate the previously active tab. The panels themselves also
// use this theme's own wc-account__panel(--active) BEM classes rather than
// Bootstrap's .tab-content/.tab-pane/.fade/.show/.active — see the matching
// display-toggle rule in account-page.less.
const ACTIVE_LINK_CLASS = 'wc-account__tabs-link--active';
const ACTIVE_PANEL_CLASS = 'wc-account__panel--active';

function switchAccountTab(nav, link) {
    const links = nav.querySelectorAll('.wc-account__tabs-link');
    const targetId = link.getAttribute('href');
    const target = targetId && document.querySelector(targetId);

    if (!target) {
        return;
    }

    links.forEach((otherLink) => {
        otherLink.classList.remove(ACTIVE_LINK_CLASS);
        otherLink.setAttribute('aria-selected', 'false');
    });
    link.classList.add(ACTIVE_LINK_CLASS);
    link.setAttribute('aria-selected', 'true');

    target.parentElement.querySelectorAll(':scope > .wc-account__panel').forEach((pane) => {
        pane.classList.remove(ACTIVE_PANEL_CLASS);
    });
    target.classList.add(ACTIVE_PANEL_CLASS);
}

function tabUrl(link) {
    const url = new URL(location.href);
    url.hash = '';
    url.searchParams.set('tab', link.getAttribute('href').slice(1));
    return url.toString();
}

function initAccountTabs(nav) {
    const links = Array.from(nav.querySelectorAll('.wc-account__tabs-link'));

    links.forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();

            if (link.classList.contains(ACTIVE_LINK_CLASS)) {
                return;
            }

            switchAccountTab(nav, link);
            history.replaceState(null, null, tabUrl(link));
        });
    });

    // The active tab is now resolved server-side from `?tab=...` (see
    // amenities_account_active_tab() / account.twig), so the initial panel already
    // paints correctly with no client-side fix-up. This only handles a bookmarked/shared
    // `#...` link from before that change, migrating it to the `?tab=` URL on the fly.
    if (location.hash) {
        const hashLink = links.find((link) => link.getAttribute('href') === location.hash);

        if (hashLink) {
            switchAccountTab(nav, hashLink);
            history.replaceState(null, null, tabUrl(hashLink));
            // Counteracts the browser's native jump-to-#fragment scroll for this
            // legacy link format (unchanged from the previous hash-based behavior).
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 400);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-account-tabs]').forEach(initAccountTabs);
});
